import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    intervalMs: { type: Number, default: 3000 }
  }

  static targets = ["pingText", "pingBadge", "pongText", "pongBadge", "emptyText"]

  connect() {
    if (!this.hasUrlValue) return
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalMsValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        cache: "no-store"
      })
      if (!response.ok) return

      const data = await response.json()
      this.render(data)
    } catch (_e) {
      // Keep silent: transient network issues should not break UI.
    }
  }

  render(data) {
    const ping = data.last_ping
    const pong = data.last_pong

    if (!ping && !pong) {
      this.showEmpty()
      return
    }

    this.hideEmpty()

    if (ping) {
      this.pingTextTarget.textContent = this.formatTime(ping.created_at)
      this.pingBadgeTarget.textContent = this.titleize(ping.state)
      this.pingBadgeTarget.className = this.badgeClass(ping.state)
    }

    if (pong) {
      this.pongTextTarget.textContent = this.formatTime(pong.created_at)
      this.pongBadgeTarget.textContent = "Round-trip OK"
      this.pongBadgeTarget.className = this.badgeClass("delivered")
    }
  }

  showEmpty() {
    if (this.hasEmptyTextTarget) this.emptyTextTarget.classList.remove("hidden")
    if (this.hasPingTextTarget) this.pingTextTarget.textContent = "-"
    if (this.hasPongTextTarget) this.pongTextTarget.textContent = "-"
  }

  hideEmpty() {
    if (this.hasEmptyTextTarget) this.emptyTextTarget.classList.add("hidden")
  }

  formatTime(isoTime) {
    const d = new Date(isoTime)
    return d.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short"
    })
  }

  titleize(value) {
    return (value || "").replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())
  }

  badgeClass(state) {
    if (state === "delivered") return "inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-green-100 text-green-700"
    if (state === "failed" || state === "exhausted") return "inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-red-100 text-red-700"
    return "inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-700"
  }
}
